import { ILabel, ILanguageRules } from "../Interfaces";

export class Rules implements ILanguageRules
{
    public getPlural(label: ILabel, count: number | string): string
    {
        return label.other;
    }
}
